export const ORGANIZATION_USER_ROLE_ADMIN = 'Admin';
export const ORGANIZATION_USER_ROLE_USER = 'User';
export const CIRCLE_USER_ROLE_USER = 'User';
export const CIRCLE_USER_ROLE_MANAGER = 'Manager';
export const NOTIFICATIONS_SEVERITY_INFO = 'Info';
export const NOTIFICATIONS_SEVERITY_WARNING = 'Warning';
export const NOTIFICATIONS_SEVERITY_CRITICAL = 'Critical';
export const CHANNEL_EMAIL = 'Email';
export const CHANNEL_SMS = 'SMS';
export const CHANNEL_REALTIME = 'Realtime'
export const ZONE_TYPE_SAFE= 'Safe';
export const ZONE_TYPE_NORMAL= 'Normal';
export const ZONE_TYPE_WARNING= 'Warning';
export const ZONE_TYPE_DANGER= 'Danger';
export const ZONE_USER_MONITORED = 'Monitored';
export const ZONE_USER_RECEIVER = 'Receiver';
export const USER_ACTIVE = 'Active';
export const USER_INVITED = 'Invited';
export const NOTIFICATION_PENDING = 'Pending';
export const NOTIFICATION_COMPLETED = 'Completed';
export const NOTIFICATION_FAILED = 'Failed';
export const GRANT_TYPE_FACEBOOK = 'Facebook';
export const GRANT_TYPE_GOOGLE = 'Google';